import { render, staticRenderFns } from "./company-tier-detail.vue?vue&type=template&id=b9f1b6f0&"
import script from "./company-tier-detail.vue?vue&type=script&lang=js&"
export * from "./company-tier-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports